module.exports = __webpack_public_path__ + "img/home-block-3-1.30d8fbf3.jpg";